// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__IWTZQ","title":"BackImages_title__2ZcIK","images":"BackImages_images__MCYIC"};